import type { QuizAttempt } from "@/react/types/QuizAttempt";
import { QuestionItem } from "./QuestionItem";

interface QuizResultProps {
  attempt: QuizAttempt;
}
export const QuizResult = ({ attempt }: QuizResultProps) => (
  <div className="flex flex-col gap-6 overflow-y-scroll sm:h-[calc(80dvh-171px)] sm:grow sm:pr-6">
    {attempt.questions.map(question => (
      <QuestionItem key={question.id} question={question} />
    ))}
  </div>
);
